// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const { showTooltip } = require('../actions')
const TooltipBubble = require('../components/bubble')
const TooltipsDismissedCache = require('../utils/dismissed-cache')

const dismissedCache = TooltipsDismissedCache.forLocalStorageKey('tooltips')

// Tooltip action dispatchers

function showUserProfileBadgeTooltip() {
  const key = 'user-profile-avatar-badge'
  return function (dispatch) {
    if (dismissedCache.get(key)) {
      return false
    }
    dispatch(showTooltip({
      key,
      renderCustom: renderUserBadgeTooltip,
      onDismiss() { dismissedCache.set(key) }
    }))
    return true
  }
}

module.exports = {
  showUserProfileBadgeTooltip
}

// Helper functions

function renderUserBadgeTooltip() {
  return tag([
    TooltipBubble.renderTitle('Verified Curator'),
    TooltipBubble.renderBody(
      `What’s this? `,
      tag('a', {
        href: 'https://community.mix.com/blog/verifiedcurator',
        target: '_blank',
        style: { color: 'inherit' }
      },
        `Learn more`
      ),
      `.`
    )
  ])
}
